<template>
  <Button
    :prepend-icon="copied ? 'check' : 'copy'"
    prepend-icon-prefix="fas"
    color="pink"
    :full-width="fullWidth"
    :disabled="disabled"
    @click="copy"
  >
    <span v-if="copied">{{ $t('copied') }}!</span>
    <span v-else>{{ label }}</span>
  </Button>
</template>

<script setup lang="ts">
const props = defineProps<{
  source: string
  label: string
  disabled?: boolean
  fullWidth?: boolean
}>()

const copied = ref(false)

// Copy synchronously within the click gesture via execCommand. Chrome and Brave
// on iOS refuse navigator.clipboard.writeText after the image download has been
// triggered, even on a fresh tap; the older execCommand gesture model is not
// affected. The textarea must be rendered (not hidden) and selected via
// setSelectionRange for the copy to succeed on iOS.
const copy = () => {
  const textarea = document.createElement('textarea')
  textarea.value = props.source
  textarea.style.position = 'absolute'
  textarea.style.left = '-9999px'
  document.body.appendChild(textarea)
  textarea.focus()
  textarea.setSelectionRange(0, textarea.value.length)
  document.execCommand('copy')
  textarea.remove()

  copied.value = true
  setTimeout(() => (copied.value = false), 2000)
}
</script>
